import { FC, useEffect, useState } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { PatientProfileProvider } from '../../../../hooks/use-patient-profile';
import { useSlideout } from '../../../../hooks/use-slideout';
import {
  EventInboxCommunicationsWidget,
  EventPatientProfile,
  EventPatientProfileWithPhoneNumber
} from '../../../../types/event-bus';
import { PatientProfileWidgetProvider } from './hooks/use-patient-profile-widget';
import { PatientProfileWidgetComponent } from './patient-profile-widget';

const PatientProfileWidgetWithProvider: FC = () => {
  const { listen } = useEventBus();
  const { currentEvent } = useSlideout();
  const [patientIdEvent, setPatientIdEvent] = useState<EventPatientProfile>();
  const [patientPhoneEvent, setPatientPhoneEvent] = useState<EventPatientProfileWithPhoneNumber>();
  const [patientInboxEvent, setPatientInboxEvent] = useState<EventInboxCommunicationsWidget>();

  useEffect(() => {
    switch (currentEvent?.messageType) {
      case 'patientProfile': {
        const event = currentEvent as EventPatientProfile;
        resetWidget();
        setTimeout(() => {
          if (event.data.patientId) setPatientIdEvent(event as EventPatientProfile);
          else setPatientPhoneEvent(currentEvent as EventPatientProfileWithPhoneNumber);
        }, 0);
        break;
      }
      case 'inboxCommunications': {
        resetWidget();
        setTimeout(() => setPatientInboxEvent(currentEvent as EventInboxCommunicationsWidget), 0);
        break;
      }
      case 'patient-profile-widget-navigation':
        break;
      default:
        resetWidget();
        break;
    }
  }, [currentEvent]);

  useEffect(() => {
    const listener = listen('closeWidget', (event) => {
      if (event.messageType === 'closeWidget') resetWidget();
    });

    return () => listener();
  }, [listen]);

  const resetWidget = () => {
    setPatientIdEvent(undefined);
    setPatientPhoneEvent(undefined);
    setPatientInboxEvent(undefined);
  };

  return patientIdEvent || patientPhoneEvent || patientInboxEvent ? (
    <PatientProfileProvider>
      <PatientProfileWidgetProvider
        patientIdEvent={patientIdEvent}
        patientPhoneEvent={patientPhoneEvent}
        patientInboxEvent={patientInboxEvent}
      >
        <PatientProfileWidgetComponent />
      </PatientProfileWidgetProvider>
    </PatientProfileProvider>
  ) : null;
};

export const PatientProfileWidget = PatientProfileWidgetWithProvider;
